import { FC } from 'react';
import './styles.scss';

interface Props {
  text: string;
}

const TagDefault: FC<Props> = ({ text }) => {
  return (
    <span className={'TagDefault'}>
      {text}
    </span>
  );
}

export default TagDefault;